








































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Subscription } from '@subscriptions/interfaces/subscription';
import DatePicker from '@shared/components/forms/inputs/datepicker/datepicker.vue';
import moment from 'moment/moment';

@Component({
  name: 'bc-reactivate-subscription-modal',
  components: {
    'bpc-date-picker': DatePicker,
  },
})
export default class ReactivateSubscriptionModal extends Vue {
  // PROPS
  @Prop({ type: Boolean, default: false }) readonly showModal: boolean;
  @Prop({ type: Object, default: null }) readonly subscription: Subscription;

  // DATA
  loading = false;
  endDate = moment().format('YYYY-MM-DD');
  nextRenewalDate = moment().format('YYYY-MM-DD');
  disabledNextRenewalDate = true;

  // COMPUTED
  // LIFECYCLE
  // METHODS

  closeModal() {
    this.$emit('close');
  }

  get isRenewable() {
    return (
      this.subscription?.subscription_category?.enable_periodic_payment &&
      this.subscription?.mandate_id
    );
  }

  async reactivateSubscription() {
    this.loading = true;
    const url = `${this.$bpcApiRouteHelper.getEntityPath('subscriptions')}/${
      this.subscription.id
    }/reactivate`;
    const params = {
      end_date: this.endDate,
      next_renewal_date: this.nextRenewalDate,
    };

    try {
      const res = await this.$bpcApi.put(url, params).toPromise();
      if (res.data) {
        this.$emit('reactivated');
      } else {
        this.$bpcMessage.showErrorMessage({ text: 'global.reactivate-subscription-error' });
        this.$emit('close-modal');
      }
    } catch (error) {
      this.$bpcMessage.showErrorMessage({ text: 'global.reactivate-subscription-error' });
    } finally {
      this.loading = false;
    }
  }

  async getSuggestedNextRenewalDate() {
    const url = `${this.$bpcApiRouteHelper.getEntityPath('subscriptions')}/${
      this.subscription.id
    }/suggested-next-renewal-date`;
    try {
      const res = await this.$bpcApi.get(url).toPromise();
      if (res.data) {
        this.nextRenewalDate = moment(res.data).format('YYYY-MM-DD');
      }
    } finally {
      this.disabledNextRenewalDate = false;
    }
  }

  @Watch('showModal')
  onShowModalChange() {
    if (this.showModal) {
      this.endDate = this.subscription?.end_date;
      if (this.isRenewable) {
        this.getSuggestedNextRenewalDate();
      }
    }
  }
}
